<template>
    <span class="event-disciplines">
        {{ formattedLabel }}
    </span>
</template>

<script setup lang="ts">
const props = defineProps<{
    disciplines: Discipline[];
}>();

const { disciplines } = toRefs(props);

const formattedLabel = computed(() => {
    if (!disciplines.value || !disciplines.value.length || disciplines.value.length === 0) {
        return '';
    }

    if (disciplines.value.length === 1) {
        return disciplines.value[0].name;
    }

    return disciplines.value.map(discipline => discipline.name).join(', ');
});
</script>
